import React from 'react';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { useConfig } from '../config-context';
/**
 * Conditional comments are used to reveal some HTML elements only inside MS products (outlook, IE).
 * You must not forget to use a closing tag <CommentEnd />.
 *
 * @example <!--[if mso | IE]>visible only in mso and IE products<![endif]-->
 */
export function CommentStart(props) {
    var _a = props.condition, condition = _a === void 0 ? 'if mso | IE' : _a;
    return (React.createElement(SecureHtml, { html: "<!--[" + condition + "]>", skipCleaning: true, as: "so-comment" }));
}
/**
 * Double conditional comments are used to hide some HTML content inside MS products (outlook, IE).
 * You must not forget to use a closing tag <DoubleCommentEnd />.
 *
 * @example <!--[if mso | IE]><!-->visible everywhere except mso and IE products<!--<![endif]-->
 */
export function DoubleCommentStart(props) {
    var config = useConfig();
    if (!config.renderComments) {
        return null;
    }
    var _a = props.condition, condition = _a === void 0 ? 'if mso | IE' : _a;
    return (React.createElement(SecureHtml, { html: "<!--[" + condition + "]><!-->", skipCleaning: true, as: "so-comment" }));
}
//# sourceMappingURL=comment-start.js.map